import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-michigan-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./michigan-state-form.component.html",
  styleUrl: "./michigan-state-form.component.scss",
})
export class MichiganStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
